import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ReloadStateService {

  private reloadCheckedSignal = signal<boolean>(false);

  readonly reloadChecked = this.reloadCheckedSignal.asReadonly();

  //it will be set to true: if reload is not done
  //fale: if reload is done
  setReloadChecked(value: boolean): void {
    this.reloadCheckedSignal.set(value);
  }

  getReloadChecked(): boolean {
    return this.reloadCheckedSignal();
  }

  reset(): void {
    this.reloadCheckedSignal.set(false);
  }
}
